import { apiFetch } from '@/lib/api-client';

// Admin-only app settings (SYSTEM_ADMIN). The escalation target = the internal Unifiber colleague a
// reviewer escalates a ticket to (one of our own app users; picked from the candidate list).

export interface EscalationTarget {
  userId: string;
  label: string;
}

export interface EscalationCandidate {
  id: string;
  displayName: string;
  email: string;
  role: string;
}

/** Active internal Unifiber users the admin can choose as the escalation target. */
export function fetchEscalationCandidates(): Promise<{ data: EscalationCandidate[] }> {
  return apiFetch<{ data: EscalationCandidate[] }>('/admin/settings/escalation-candidates');
}

/** The two-level escalation chain (2026-08-03): validators hand to level 1; level 1 hands UP to level 2. */
export interface EscalationChain {
  level1: EscalationTarget | null;
  level2: EscalationTarget | null;
}

export function fetchEscalationTarget(): Promise<{ data: EscalationChain }> {
  return apiFetch<{ data: EscalationChain }>('/admin/settings/escalation-target');
}

export function saveEscalationTarget(userId: string, level2UserId: string | null): Promise<{ data: EscalationChain }> {
  return apiFetch<{ data: EscalationChain }>('/admin/settings/escalation-target', {
    method: 'PUT',
    body: JSON.stringify({ userId, level2UserId }),
  });
}

// ── Build hand-off target (#5 "Send to Build") — an ASSIGNEE + WATCHERS, each a Uniticket user (by email),
// NOT one of our app users. Send-to-Build reassigns the Uniticket ticket to the assignee and adds the
// watchers via the Uniticket internal API, so the Build team can follow + reply on the thread. ──

export interface BuildPerson {
  email: string;
  label: string;
}

export interface BuildTarget {
  assignee: BuildPerson;
  watchers: BuildPerson[];
}

export function fetchBuildTarget(): Promise<{ data: BuildTarget | null }> {
  return apiFetch<{ data: BuildTarget | null }>('/admin/settings/build-target');
}

export function saveBuildTarget(input: BuildTarget): Promise<{ data: BuildTarget }> {
  return apiFetch<{ data: BuildTarget }>('/admin/settings/build-target', {
    method: 'PUT',
    body: JSON.stringify(input),
  });
}
